import { lazy } from "react"
import type { FC, LazyExoticComponent, ReactElement } from "react"

import { ErrorBoundary } from "react-error-boundary"

import { ErrorHint, Loadable, RootLoaderFallback } from "@/3514/components"

import styles from "./coach.calendar.styles"

const Container: LazyExoticComponent<FC> = lazy(
    (): Promise<{ default: FC }> => import("@/pages/coach-calendar-setting/CoachAvailability")
)

const Page: FC = (): ReactElement => (
    <ErrorBoundary fallback={<ErrorHint isVisible />}>
        <Loadable
            component={Container}
            componentProps={{ classes: styles.calendarAvailability }}
            loadingFallback={<RootLoaderFallback top="10%" />}
        />
    </ErrorBoundary>
)

Page.displayName = "CoachCalendarAvailabilityPage"

export { Page as CoachCalendarAvailabilityPage }
